<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
@if (alertSucesso === true) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" alt="Representa sucesso na consulta das informações" width="82px">
      <p class="titulo-alert mt-4"> {{ alertSucessoSubtitulo }} </p>
      <div class="footer-alert bg-light">
        <p class="subtitulo-alert"> {{ alertSucessoMensagem }} </p>
        <button class="btn-borda-verde bnt-font3 btn-grande-verde mt-3" (click)="fecharAlertSucesso()">SAIR</button>
      </div>
    </div>
  </div>
}

@if (erro === true) {
  <div class="body-senha">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/error.png" alt="Erro" width="82px">
      <p class="titulo-alert mt-4 c-danger"> {{ alertErroSubtitulo }}
      </p>
      <div class="footer-alert bg-danger">
        <p class="subtitulo-alert2"> {{ alertErroMensagem }} </p>
        <button class="btn-borda-branca bnt-font4 btn-grande3 mt-3" (click)="fecharAlertErro()">SAIR</button>
      </div>
    </div>
  </div>
}

@if (alertAlterarEmpresa) {
  <div class="body-alert">
    <div class="tamanhoBox">
      <div class="row mt-3">
        <div class="col-lg-12">
          <h1 class="titulo">Confirmação de contrato</h1>
          <p class="paragrafo mt-2">Confirme os dados antes da contratação</p>
        </div>
      </div>
      @if (consultaMensal) {
        <table class="table table-hover border-bottom mt-1" aria-describedby="tabela de coltas">
          <thead>
            <tr>
              <th scope="col">Consultas</th>
              <th scope="col">Mensalidades</th>
              <th scope="col">Excedentes</th>
              <th scope="col">Download em PDF</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{consultaSelecionada?.qtdeMaxRoteirizacoesMes}}</td>
              <td>{{$safeNavigationMigration(consultaSelecionada?.valorMensalRoteirizacao) |  currency:"BRL":"symbol"}}</td>
              <td>{{$safeNavigationMigration(consultaSelecionada?.valorExcedePfx) |  currency:"BRL":"symbol"}}</td>
              <td class="text-center">
                <button
                  class="btn-icon"
                  aria-label="Baixar contrato"
                  (click)="getDownloadContratado()"
                  >
                  <i class="fa fa-download fa-2x c-primary hand" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      }
      @if (consultaAvulsa) {
        <table class="table table-hover border-bottom mt-4">
          <caption>Tabela com lista de consultas avulsas</caption>
          <thead>
            <tr>
              <th scope="col">Consultas</th>
              <th scope="col">Valor</th>
              <th scope="col">Download em PDF</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Livre</td>
              <td>{{consultaSelecionada?.VlExcentente}}</td>
              <td class="text-center">
                <button
                  class="btn-icon"
                  aria-label="Baixar contrato"
                  (click)="getDownloadContratado()"
                  >
                  <i class="fa fa-download fa-2x c-primary" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      }
      <p class="text-center titulo-contrato">CONTRATO ROTEIRIZAÇÃO</p>
      <p clas="legenda text-center">Antes de prosseguir com o
        contrato de rota inteligente, por favor, leia atentamente
        a informação abaixo <br> e selecione uma das opções CONCORDO ou DISCORDO, ao
      final da página, conforme sua decisão</p>
      <div class="col-lg-12">
        <textarea rows="5" cols="70" id="detalhes" class="border" readonly>
          Dados da Empresa: {{resources?.dadosDaEmpresa}}
          Nome Fantasia: {{resources?.nomeFantasia}}
          CNPJ: {{resources?.codigoCnpj}}
          Endereço: {{resources?.endereco}}
          TERMO DE ADESÃO AO SERVIÇO DE ROTEIRIZAÇÃO
          O presente Termo representará a adesão &agrave;s condições de uso do serviço de roteirização, oferecido pela Alelo, aos clientes interessados (&quot;Clientes&quot;), nos seguintes termos:
          I - OBJETO
          I.1 - O presente Termo de adesão tem como objeto o serviço de roteirização (&quot;Serviço&quot;), oferecido pela Alelo, que implica em sugestão de rotas de transporte aos colaboradores indicados pelos clientes, possibilitando, conforme o caso, a adequação do custo com o benefício vale-transporte bem como a simplificação do processo de aquisição.
          II - CONDIÇÕES DE EXECUÇãO DO SERVIÇO
          II.1 - Para que a Alelo possa executar o Serviço, os Clientes deverão indicar, atrav&eacute;s do sistema de gestão de vale-transporte da Alelo, a qual colaborador será destinada a roteirização, informando o endereço completo de sua residência, o endereço completo do local de trabalho, bem como qualquer outra informação necessária &agrave; execução do Serviço que seja expressamente solicitada pela Alelo.
          II.2 - Ap&oacute;s o recebimento das informações transmitidas pelos Clientes, a Alelo quantificará, de forma estimativa, os vales-transporte necessários para a locomoção do colaborador indicado.
          II.3 - A Alelo não está obrigada a confirmar as informações transmitidas pelos Clientes, que comprometem-se a sempre passar informações claras, corretas, atualizadas e completas.
          II.4 - Será de responsabilidade exclusiva dos Clientes toda e qualquer falha ou incorreção do Serviço decorrentes de informações incorretas, falsas, desatualizadas ou incompletas transmitidas pelos Clientes.
          III - TAXA DE ROTEIRIZAÇãO
          III.1 - Em contraprestação ao Serviço objeto do presente Termo, os Clientes deverão pagar &agrave; Alelo os valores correspondentes &agrave; modalidade contratada conforme segue:
          a) Plano Mensal: significa a cobrança realizada a cada mês, no sistema Alelo, com número fixo de consultas que serão definidos no momento da contratação do serviço e conforme Anexo I. As consultas não utilizadas não são cumulativas. Caso o cliente faça mais consultas do que o plano permitir, será cobrado um valor excedente, diferente do valor da consulta indicada no plano.
          b) Plano Consulta Avulsa: significa a cobrança por consulta, conforme Anexo I, realizada de forma avulsa distinta daquela Contratada, conforme item 'a' acima. As consultas de usuários cadastrados serão realizadas no sistema Alelo.
          III.2 - Os valores dos Planos classificados acima poderão ser reajustadas, nos termos dispostos no Contrato de Serviços de Aquisição de Benefícios, firmado entre a Alelo e os Clientes (Contrato).
          III.3 - Se os Clientes estiverem em falta no cumprimento de qualquer das condições ora contratadas, a Alelo estará desobrigada de prestar o Serviço durante o prazo em que a falta persistir, sem prejuízo da faculdade de seu cancelamento sem &ocirc;nus para a Alelo.
          IV - PRAZO E CANCELAMENTO DO SERVIçO
          IV.1 - A adesão ao Serviço permanecerá em vigor de acordo com o prazo de vigência estabelecido no Contrato, podendo o cliente solicitar seu cancelamento a qualquer tempo, mediante aviso pr&eacute;vio e expresso, com 30 (trinta) dias de antecedências, ressalvado o disposto na cláusula IV.2 abaixo.
          IV.2 - Os Clientes deverão obedecer o prazo mínimo de vigência de 12 (doze) meses, contados a partir de seu aceite, sendo que eventual solicitação de cancelamento do Serviço por parte dos Clientes durante esse período ensejará o pagamento de 50% (cinq&uuml;enta por cento) do valor a ser cobrado pela Alelo nos meses restantes, de acordo com o Serviço prestado no mês antecedente ao do pedido de cancelamento, exceto para o plano Consulta Avulsa.
          V - CONDIÇÕES GERAIS
          V.1 - Os Clientes, neste ato, declaram reconhecer que toda e qualquer rota indicada pela Alelo, nos termos ora contratados, serão meramente sugestivas, cabendo aos Clientes, a seu exclusivo crit&eacute;rio, a avaliação da viabilidade de aplicação das rotas sugeridas, não sendo devido qualquer valor pela Alelo em virtude de sua não utilização.
          V.2 - Os Clientes declaram, no presente ato, plena ciência de que o sistema utilizado pela Alelo depende de atualização da base de dados de logradouros de CEP e de tipos e rotas do transporte público, sendo que, eventualmente, algumas localidades apontadas como residência do usuário ou da empresa podem eventualmente não ser encontradas, neste caso, a consulta não será cobrada.
          V.3 - A Alelo poderá introduzir qualquer modificação ao presente termo, mediante comunicação aos Clientes, inclusive atrav&eacute;s de mensagens nas correspondências a ele encaminhadas, correspondências virtuais (e-mail) e divulgação neste website. O não exercício do direito de denunciar a adesão, no prazo de 10 (dez) dias úteis a partir da comunicação ou divulgação, implica de pleno direito, na aceitação e adesão irrestrita dos Clientes &agrave;s novas condições.
          V.4 - A Alelo poderá, a qualquer tempo e a seu exclusivo crit&eacute;rio, alterar as premissas utilizadas para os cálculos de cobrança de tarifas, previstas na cláusula III.1 do presente termo, mediante comunicação aos Clientes, inclusive atrav&eacute;s de mensagens nas correspondências a ele encaminhadas, correspondências virtuais (e-mail) e divulgação neste website. O não exercício do direito de denunciar a adesão, no prazo de 10 (dez) dias úteis a partir da comunicação ou divulgação, implica de pleno direito, na aceitação e adesão irrestrita dos Clientes &agrave;s novas condições.
          V.5 - Ao Serviço ora aderido, aplicam-se todas as disposições do Contrato que não sejam conflitantes com o presente Termo.
          V.6 - Os Clientes declaram que leram atentamente e estão de acordo com todas as disposições do presente termo de adesão.
          ANEXO I
          TABELAS DE VALORES DOS PLANOS
          1. Tabela Plano Mensal:
          Consultas	    Mensalidade	    Consulta Excedente
          1	                    {{this.planoMensal[0].vlRotMensalFmt}}	            {{this.planoMensal[0].vlExcendenteFmt}}
          2	                    {{this.planoMensal[1].vlRotMensalFmt}}	            {{this.planoMensal[1].vlExcendenteFmt}}
          3	                    {{this.planoMensal[2].vlRotMensalFmt}}	            {{this.planoMensal[2].vlExcendenteFmt}}
          4	                    {{this.planoMensal[3].vlRotMensalFmt}}	            {{this.planoMensal[3].vlExcendenteFmt}}
          5	                    {{this.planoMensal[4].vlRotMensalFmt}}	            {{this.planoMensal[4].vlExcendenteFmt}}
          10	                    {{this.planoMensal[5].vlRotMensalFmt}}	            {{this.planoMensal[5].vlExcendenteFmt}}
          20	                    {{this.planoMensal[6].vlRotMensalFmt}}	            {{this.planoMensal[6].vlExcendenteFmt}}
          30	                    {{this.planoMensal[7].vlRotMensalFmt}}	            {{this.planoMensal[7].vlExcendenteFmt}}
          50	                    {{this.planoMensal[8].vlRotMensalFmt}}	            {{this.planoMensal[8].vlExcendenteFmt}}
          60	                    {{this.planoMensal[9].vlRotMensalFmt}}	            {{this.planoMensal[9].vlExcendenteFmt}}
          70	                    {{this.planoMensal[10].vlRotMensalFmt}}	            {{this.planoMensal[10].vlExcendenteFmt}}
          100	                    {{this.planoMensal[11].vlRotMensalFmt}}	            {{this.planoMensal[11].vlExcendenteFmt}}
          150	                    {{this.planoMensal[12].vlRotMensalFmt}}	            {{this.planoMensal[12].vlExcendenteFmt}}
          200	                    {{this.planoMensal[13].vlRotMensalFmt}}	            {{this.planoMensal[13].vlExcendenteFmt}}
          300	                    {{this.planoMensal[14].vlRotMensalFmt}}	    {{this.planoMensal[14].vlExcendenteFmt}}
          500	                    {{this.planoMensal[15].vlRotMensalFmt}}	    {{this.planoMensal[15].vlExcendenteFmt}}
          800	                    {{this.planoMensal[16].vlRotMensalFmt}}	    {{this.planoMensal[16].vlExcendenteFmt}}
          1000	            {{this.planoMensal[17].vlRotMensalFmt}}	    {{this.planoMensal[17].vlExcendenteFmt}}
          2. Tabela Consulta Avulsa:
          Tipo :	Valor
          Consulta Avulsa :	R$ 24,00
          Razão Social: {{resources?.razaoSocialMatriz}}
          CNPJ : {{resources?.cnpjMatriz}}
          Nome do Interlocutor : {{resources?.interloc}}
          Data da aceitação : {{data}}
          Hora : {{hora}}
          Endereço de IP : {{ipUsuario}}
        </textarea>
      </div>
      <div class="row">
        <div class="col-lg-1">
          <div class="form-check form-check-inline ms-2 align-items-center">
            <input
              type="checkbox"
              id="Csv"
              class="form-check-input"
              value="Csv"
              name="codigoTipoRelatorio"
              (change)='verificarContrato()'>
            <label class="form-check-label" for="Csv"></label>
          </div>
        </div>
        <div class="col-lg-11 mt-2">
          <p class="legenda"> Ao dar o Check você concorda e esta ciente com os termos de
          utilização deste serviço. Caso contrário, clique em cancelar e volte a página anterior.</p>
        </div>
      </div>
      <div class="row h-18">
        <div class="footer-alert footer w-100 h-100">
          <div class="text-center ">
            <p class="mb-4 c-white">Confirma a contratação do serviço?</p>
            @if (checkContrato === false) {
              <button class="botao buttonTrocar bnt-font disabled"
              disabled>Confirmar</button>
            }
            @if (checkContrato) {
              <button class="botao buttonTrocar bnt-font "
              (click)='getPlanoContratado()'>Confirmar</button>
            }
            <button type="button" class="btn-borda-verde-claro btn-font-verde-claro ms-4 btn-grande-verde"
            (click)="cancelarAlterarEmpresa()">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}